<template>
  <div class="f-items-progressing">
    <div class="header" @click="opened = !opened">
      <div class="icon s16">
        <f-fade-transition>
          <f-icon v-if="!opened" key="up" icon="fa6-chevron-up"></f-icon>
          <f-icon v-else key="down" icon="fa6-chevron-down"></f-icon>
        </f-fade-transition>
      </div>
      <div class="title">
        {{ name }}
        <f-bullet-number
          type="overlay"
          :number="items.length"
        ></f-bullet-number>
      </div>
      <div class="right">
        <f-fade-transition mode="out-in">
          <f-button
            v-if="!completed && opened"
            key="collapse"
            type="small tertiary"
          >
            Collapse
          </f-button>
          <f-loader-circular
            v-else-if="!completed && !opened"
            key="progress"
            size="24px"
            :progress="progress"
            :pending="completed && progress < 1"
            overlay
          >
          </f-loader-circular>
          <f-button
            v-else-if="completed"
            key="completed"
            type="small tertiary"
            @click.stop="close"
          >
            close
          </f-button>
        </f-fade-transition>
      </div>
    </div>
    <div
      class="details"
      :class="{ opened }"
      :style="{ '--heightNumber': Math.min(items.length, 3) }"
    >
      <f-sexy-scroll class="items">
        <component
          v-for="item in items"
          :key="item._key"
          :is="item.vueComponent"
          :item="item"
          :component="item.component"
          @completed="updateCompleted(item)"
          @error="updateError(item)"
          @progress="(progress) => updateProgress(item, progress)"
          @cancel="cancel(item)"
          @dismiss="dismiss(item)"
        ></component>
      </f-sexy-scroll>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: Array,
    name: { type: String, default: "Progressing" },
  },
  data() {
    return {
      opened: false,
    };
  },
  watch: {
    items(items) {
      if (items.length === 0) {
        this.close();
      }
    },
  },
  computed: {
    completed() {
      return this.items.every((item) => item.completed || item.error);
    },
    progress() {
      return (
        this.items.reduce((acc, item) => acc + (item.progress || 0), 0) /
        this.items.length
      );
    },
  },
  methods: {
    dismiss(item) {
      item.remove();
    },
    cancel(item) {
      item.cancel && item.cancel();
    },
    updateProgress(item, progress) {
      this.$set(item, "progress", progress);
    },
    updateCompleted(item) {
      this.$set(item, "completed", true);
    },
    updateError(item) {
      this.$set(item, "error", true);
    },
    close() {
      Array.from(this.items).forEach((i) => i.remove());
      // this.items.forEach((i) => i.remove());
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss">
.f-items-progressing {
  overflow: hidden;
  border-radius: 8px;

  text-align: initial;

  /* Drop shadow / Modal */
  box-shadow: 0px 24px 48px rgba(22, 22, 21, 0.25);

  width: 337px;

  .header {
    width: 100%;
    background-color: var(--black-a90);
    height: 56px;
    color: var(--white);

    cursor: pointer;

    display: flex;
    gap: 16px;
    flex-direction: row;
    align-items: center;
    padding: 8px 16px;

    /* Headline/H6 */
    font-family: "Lato";
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;

    > * {
      display: flex;
      flex-direction: row;
    }

    .icon {
      position: relative;
      width: 16px;
      height: 16px;
      flex: 0 0 16px;
      > * {
        position: absolute;
        width: 100%;
        height: 100%;
      }
    }

    .title {
      flex: 0 1 100%;
      display: flex;
      flex-direction: row;
      gap: 8px;
      align-items: center;
    }
  }

  .details {
    width: 100%;
    height: 0;

    transition: height 125ms ease;

    background-color: var(--white);

    &.opened {
      height: calc(var(--heightNumber) * 64px);
      height: calc(3 * 64px);
    }

    display: flex;
    flex-direction: column;
    align-items: stretch;

    .items {
      flex: 0 0 (3 * 64px);
      height: 3 * 64px;
    }
    // .actions {
    //   flex: 0 0 40px;
    //   justify-content: center;
    //   align-items: center;
    // }
  }
}

.dark-mode {
  .f-items-progressing {
    color: var(--white-a75);
    .header {
      background-color: #000;
      color: var(--white-a75);
    }
    .details {
      background-color: #000;
    }
  }
}
</style>